import { Component, inject } from '@angular/core';
import { ApplicationStore, ApplicationStoreType } from '../../../core/store/application.store';
import { Toast } from '../../types/toast';

@Component({
    selector: 'juyo-toast-container',
    styleUrl: 'toast-container.scss',
    template: `
        <div class="toast-container">
            @for (toast of applicationStore.toasts(); track toast.id) {
                <div
                    class="toast shown show"
                    [class.toast--success]="toast.isSuccess"
                    [class.toast--error]="toast.isError"
                    [class.toast--warning]="toast.isWarning"
                    [class.toast--info]="toast.isInfo"
                >
                    <div class="toast-title">
                        <span>{{ toast.type }}</span>
                        <span class="toast-close" (click)="onRemove(toast)">
                        <span class="material-symbols-outlined"> close_small </span>
                    </span>
                    </div>
                    <div class="toast-message">
                        @for (message of toast.messages; track $index) {
                            <div class="toast-message-text">{{ message }}</div>
                        }
                    </div>
                </div>
            }
        </div>
    `
})
export class ToastContainerComponent {

    protected applicationStore: ApplicationStoreType = inject(ApplicationStore);

    public onRemove(toast: Toast) {
        this.applicationStore.removeToast(toast);
    }
}
